/* Reads the existing Shopify cart. It never adds, removes or changes items. */
if (!customElements.get('course-utility-bar')) {
  customElements.define('course-utility-bar', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = new AbortController();
      this.requestNumber = 0;
      this.cartLink = this.querySelector('.course-utility__cart');
      this.count = this.querySelector('[data-cart-count]');
      this.status = this.querySelector('[data-cart-status]');
      this.statusLabel = this.status.textContent.replace(/:\s*\d+\s*$/, '');
      const options = { signal: this.lifecycle.signal };
      this.queueRefresh = () => {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 100);
      };
      document.addEventListener('cart:update', this.queueRefresh, options);
      window.addEventListener('pageshow', this.queueRefresh, options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.queueRefresh();
      }, options);
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.fetchController?.abort();
      clearTimeout(this.refreshTimer);
    }
    async refresh() {
      this.fetchController?.abort();
      this.fetchController = new AbortController();
      const requestNumber = ++this.requestNumber;
      try {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json' }, signal: this.fetchController.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || requestNumber !== this.requestNumber || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        const count = cart.item_count;
        this.cartLink.hidden = count === 0;
        this.count.textContent = count > 99 ? '99+' : String(count);
        this.status.textContent = `${this.statusLabel}: ${count}`;
      } catch (_) {
        // Keep the server-rendered count and working cart link on a network failure.
      }
    }
  });
}
